import {combineReducers} from "redux";
import {createItemReducer} from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function helpReducer() {
    return combineReducers({
        getHelpMembers: createItemReducer("CarrierHome", "HelpContent.GetMembers", false),
        getList: createItemReducer("CarrierHome", "HelpPage.List", false),
        describe: createItemReducer("CarrierHome", "HelpPage.Describe", false)
    });
}